// removed by extract-text-webpack-plugin
module.exports = {"mod_default":"_2upId"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/VideoTag/styles.scss
 ** module id = 466
 ** module chunks = 0
 **/